import { useEffect } from "react";

import { PATHS } from "@/constants/paths";

const SHORTCUT_KEY = "k";

interface IUseGlobalSearchShortcutProps {
  isEnabled: boolean;
  onToggle: () => void;
}

// NOTE: NSAI-6589 — Cmd+K (macOS) / Ctrl+K (everywhere else) toggles the
// palette from any page, text fields included: that is where people reach for
// it, and no editor in the app binds the combination itself. Matched on `key`
// case-insensitively so Shift or Caps Lock does not defeat it. The admin panel
// has a palette of its own (NSAI-6610) on the same shortcut, so this one stays
// silent on /admin even if both ever end up mounted at once.
export const useGlobalSearchShortcut = ({
  isEnabled,
  onToggle,
}: IUseGlobalSearchShortcutProps): void => {
  useEffect(() => {
    if (!isEnabled) return undefined;

    const handleKeyDown = (event: KeyboardEvent): void => {
      if (
        !globalThis.location.pathname.startsWith(PATHS.ADMIN.ROOT) &&
        (event.metaKey || event.ctrlKey) &&
        !event.altKey &&
        event.key.toLowerCase() === SHORTCUT_KEY
      ) {
        event.preventDefault();
        onToggle();
      }
    };

    globalThis.addEventListener("keydown", handleKeyDown);
    return () => {
      globalThis.removeEventListener("keydown", handleKeyDown);
    };
  }, [isEnabled, onToggle]);
};
